import { Flex, Typography } from "antd";
import styles from "./tabLabel.module.css";

interface TabLabelProps {
  title: string;
  count?: number;
}

export const TabLabel = ({ title, count }: TabLabelProps) => {
  return (
    <Flex gap="small" align="center">
      <Typography.Text>{title}</Typography.Text>
      {!!count && (
        <div className={styles.countBadge}>
          <Typography.Text className={styles.countText}>{count}</Typography.Text>
        </div>
      )}
    </Flex>
  );
};
